import {
	CONVERT_LEAD_FAIL,
	CONVERT_LEAD_SUCCESS,
	GET_ALL_AGREEMENTS_SUCCESS,
	GET_AUDIT_TRAIL_FAIL,
	GET_AUDIT_TRAIL_SUCCESS,
	GET_PURCHASERS_FAIL,
	GET_PURCHASERS_SUCCESS,
	GET_PURCHASER_BY_ID_FAIL,
	GET_PURCHASER_BY_ID_SUCCESS,
	GET_COOLING_SUCCESS,
	GET_COOLING_FAIL,
	GET_DOC_TARGET_SUCCESS,
	GET_DOC_TARGET_FAIL,
	SET_LOADING_SUCCESS,
	SET_LOADING_FAIL,
} from './types';

const initialState = {
	purchaserList: {},
	convertLead: '',
	agreements: [],
	purchaserById: {},
	auditTrail: {},
	coolingPeriodStart: '',
	documentTarget: {},
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_PURCHASERS_SUCCESS:
		case GET_PURCHASERS_FAIL:
			return {
				...state,
				purchaserList: payload,
				loading: false,
			};
		case GET_PURCHASER_BY_ID_SUCCESS:
		case GET_PURCHASER_BY_ID_FAIL:
			return {
				...state,
				purchaserById: payload,
				loading: false,
			};
		case GET_ALL_AGREEMENTS_SUCCESS:
			return {
				...state,
				agreements: payload,
				loading: false,
			};
		case CONVERT_LEAD_SUCCESS:
		case CONVERT_LEAD_FAIL:
			return {
				...state,
				convertLead: payload,
				loading: false,
			};
		case GET_AUDIT_TRAIL_SUCCESS:
		case GET_AUDIT_TRAIL_FAIL:
			return {
				...state,
				auditTrail: payload,
				loading: false,
			};
		case GET_COOLING_SUCCESS:
			return {
				...state,
				coolingPeriodStart: payload,
				loading: false,
			};
		case GET_COOLING_FAIL:
			return {
				...state,
				coolingPeriodStart: '',
				loading: false,
			};

		case GET_DOC_TARGET_SUCCESS:
		case GET_DOC_TARGET_FAIL:
			return {
				...state,
				documentTarget: payload,
				loading: false,
			};
		case SET_LOADING_SUCCESS:
		case SET_LOADING_FAIL:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
}
